class config {
    static BACKEND_URL = 'https://api.questera.ai/';
    static BASE_IPFS_URL = "https://pin.questprotocol.xyz/ipfs/"
    static BACKEND_URL_STAGING = 'https://staging-api.questera.ai/';
    static FLAG_CONSTRAINTS = {
        OnboardingFlag: "quest.sdk.onboardings",
        AnalyticsFlag: "quest.sdk.analytics",
        PaymentFlag: "quest.sdk.payment",
        ChatFlag: "quest.sdk.chat",
        FeedbackWorkflowFlag: "quest.sdk.feedback_workflow",
        GetStartedFlag: "quest.sdk.get_started",
    }

    static PHRASE_PROJECT_ID = 'e618cdb0b6998e73076a4e43a2fbe7ed';
    static PHRASE_ACCESS_TOKEN = 'c7e17018c71c5d07b970b4de79983c94a6403c883bd80e66a0b70e70d7e6c527';
}

export default config;